import { useEffect } from "react";
import type {
  FieldValues,
  UseFormSetValue,
  Path,
  PathValue,
} from "react-hook-form";
import { usePage } from "./usePage";

type UseModalOpenWithCoordinatesProps<T extends FieldValues> = {
  open: boolean;
  dataModal?: { latitude?: number; longitude?: number };
  setValue: UseFormSetValue<T>;
};

export function useModalOpenWithCoordinates<T extends FieldValues>({
  open,
  setValue,
}: UseModalOpenWithCoordinatesProps<T>) {
  const { dataModal } = usePage();

  useEffect(() => {
    if (open) {
      if (dataModal && Object.keys(dataModal).length > 0) {
        setValue(
          "latitude" as Path<T>,
          (dataModal.latitude != null
            ? String(dataModal.latitude)
            : "") as PathValue<T, Path<T>>,
        );
        setValue(
          "longitude" as Path<T>,
          (dataModal.longitude != null
            ? String(dataModal.longitude)
            : "") as PathValue<T, Path<T>>,
        );
      }
    }
  }, [open, dataModal, setValue]);
}
